<script>
import AppHeader from "@/mobile/AppHeader.vue";
export default {
  name: "AppBaseView",
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    setViewport() {
      const viewportWidth = 'device-width';
      const mvp = document.getElementById('metaviewport');
      mvp.setAttribute('content','user-scalable=no,width=' + viewportWidth);
    },
  },
  mounted() {
    this.setViewport();
  }
}
</script>

<template>
<div class="app-base-view-wrap">
  <app-header v-if="showHeader" />
  <div class="app-content">
    <slot/>
  </div>
</div>
</template>

<style scoped>
.app-base-view-wrap {
  height: 100vh;
  background: #fff;
}

</style>